import css from 'styled-jsx/css';
import { colors } from '../../config/styles';

const ProductLandingContainerStyles = css`
  .pdp-hardline {
    background-color: ${colors.gray.shade6};
  }
`;

export { ProductLandingContainerStyles };
